import { Component, ChangeDetectionStrategy, input, output } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { SearchInputComponent } from '@custom-components/general/search-input/search-input.component';
import { UserMenuComponent } from '@custom-components/layout/header/user-menu/user-menu.component';
import { Partner } from '@core/models';

@Component({
  selector: 'xemex-header-bar',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatIconModule, SearchInputComponent, UserMenuComponent],
  templateUrl: './header-bar.component.html',
  styleUrl: './header-bar.component.scss',
})
export class HeaderBarComponent {
  searchValue = input<string>('');
  searchPlaceholder = input<string>('Search here...');
  userName = input<string>('');
  userAvatar = input<string>('');
  isLoading = input<boolean>(false);
  partners = input<Partner[]>([]);
  docsUrl = input<string>('');

  menuIconChange = output<void>();
  searchChange = output<string>();
  logout = output<void>();
  partnerSelect = output<Partner>();
  profileClick = output<void>();
  aboutClick = output<void>();
}
